// Copyright (c) Move Closer 2022.

import { ConnectorMiddleware, FoundResource, Headers, Injectable, IResponse, Payload } from '@movecloser/front-core'

import { ISessionService } from './session.service'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
@Injectable()
export class SessionMiddleware implements ConnectorMiddleware {
  constructor (private readonly sessionService: ISessionService) {

  }

  public afterCall (response: IResponse): void {
    if (typeof window === 'undefined') {
      return
    }

    const params = new URLSearchParams(window.location.search)

    if (response.status === 409 && (params.has('authRequired') || params.get('loyalty') === 'eq:faf')) {
      params.delete('authRequired')

      const path = window.location.pathname
      const query = params.toString()
      const url = path + (query ? `?${query}` : '')

      window.location.href = `/auth?desiredUrl=${encodeURIComponent(url)}`
    }
  }

  public beforeCall (
    resource: FoundResource,
    headers: Headers,
    body: Payload
  ): { headers: Headers; body: Payload } | Promise<{ headers: Headers; body: Payload }> {
    if (this.sessionService.sessionToken) {
      headers['X-Session'] = this.sessionService.sessionToken
    }

    return { headers, body }
  }
}

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const SessionMiddlewareType = Symbol.for('ISessionMiddleware')
